import { Box } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { useRef } from "react"
import styled from "styled-components"

import { getUrlProps } from "helpers/landing"

import Image from "./image"
import Textarea from "./textarea"

const Container = styled(Box).attrs((props) => ({
  mb: { _: 7, tablet: 9 },
  ...props,
}))``

const TextBox = styled(Box).attrs((props) => ({
  bg: "white",
  mt: { _: "-40px", tablet: "-55px" },
  mx: "auto",
  textAlign: "center",
  width: { _: "80vw", tablet: "500px" },
  ...props,
}))`
  position: relative;
`

const TextBlock = styled(Box).attrs((props) => ({
  pointer: true,
  pt: { _: "22px", tablet: "29px" },
  px: { _: 3, tablet: 4 },
  ...props,
}))``

const ImageCenteredBox = ({ element, firstElement }) => {
  const blockRef = useRef()
  const urlProps = getUrlProps(
    element?.image?.url,
    element?.anchor_name || element?.id
  )
  const { containWide, ...style } = element?.style || {}

  return (
    <Box containWide={element?.contain || containWide}>
      <Container {...style}>
        <Box {...urlProps} {...element.image.style}>
          <Image image={element.image} linkClickData={element.id} />
        </Box>
        <TextBox {...element.textarea.style}>
          <TextBlock
            onClick={() => {
              if (blockRef.current) {
                blockRef.current.querySelector("a").click()
              }
            }}
            ref={blockRef}
            {...element.container_style}
          >
            <Textarea
              element={element.textarea}
              firstElement={firstElement}
              linkClickData={element?.anchor_name || element?.id}
            />
          </TextBlock>
        </TextBox>
      </Container>
    </Box>
  )
}

ImageCenteredBox.propTypes = {
  element: PropTypes.object,
  firstElement: PropTypes.bool,
  lazyload: PropTypes.bool,
}

export default ImageCenteredBox
